// extracted by mini-css-extract-plugin
module.exports = {"UploadForm__fileInput":"UploadForm_UploadForm__fileInput__21kH-","UploadForm__languageSelected":"UploadForm_UploadForm__languageSelected__3m99R"};